module.exports = __webpack_public_path__ + "img/saveButtonIcon.51f345a4.svg";